import React from "react";
import { useTranslation } from 'react-i18next';

const KalitePolitikamiz = () => {
  const { t } = useTranslation();

  const politikalar = [
    {
      baslik: t('qualityPolicy.policies.customerSatisfaction.title'),
      aciklama: t('qualityPolicy.policies.customerSatisfaction.description'),
    },
    {
      baslik: t('qualityPolicy.policies.reliability.title'),
      aciklama: t('qualityPolicy.policies.reliability.description'),
    },
    {
      baslik: t('qualityPolicy.policies.ethicalValues.title'),
      aciklama: t('qualityPolicy.policies.ethicalValues.description'),
    },
    {
      baslik: t('qualityPolicy.policies.customerFocus.title'),
      aciklama: t('qualityPolicy.policies.customerFocus.description'),
    },
    {
      baslik: t('qualityPolicy.policies.quickSolution.title'),
      aciklama: t('qualityPolicy.policies.quickSolution.description'),
    },
  ];

  return (
    <section className="section">
      <div className="mx-auto w-full max-w-3xl px-5 sm:px-6">
        <div className="page-head">
          <h1 className="page-title">{t('qualityPolicy.title')}</h1>
        </div>

        <div className="divide-y divide-line border-y border-line">
          {politikalar.map((p, i) => (
            <div key={i} className="flex gap-6 py-7">
              <span className="w-6 shrink-0 pt-0.5 text-[13px] font-semibold tabular-nums text-muted">
                {String(i + 1).padStart(2, "0")}
              </span>
              <div>
                <h2 className="text-[16px] font-semibold text-ink">
                  {p.baslik}
                </h2>
                <p className="mt-2 text-[15px] leading-relaxed text-body">
                  {p.aciklama}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default KalitePolitikamiz;